import doge1 from "assets/images/mintedDoge/doge1.png";
import doge2 from "assets/images/mintedDoge/doge2.png";
import doge3 from "assets/images/mintedDoge/doge3.png";
import doge4 from "assets/images/mintedDoge/doge4.png";
import doge5 from "assets/images/mintedDoge/doge5.png";
import doge6 from "assets/images/mintedDoge/doge6.png";

export const mintedDoge = [
  {
    id: 241,
    price: 0.8,
    img: doge1,
  },
  {
    id: 242,
    price: 0.8,
    img: doge2,
  },
  {
    id: 243,
    price: 0.8,
    img: doge3,
  },
  {
    id: 244,
    price: 0.8,
    img: doge4,
  },
  {
    id: 245,
    price: 0.8,
    img: doge5,
  },
  {
    id: 246,
    price: 0.8,
    img: doge6,
  },
];
